import StatsTab from "../storageRoles/StatsTab";
import { useGetDealerRolesFirmConsumentLogReportQuery } from "../../../../store";

export default function DealerRolesStatsTab({ firm }) {
  return <StatsTab firm={firm} useStatsQuery={useGetDealerRolesFirmConsumentLogReportQuery} />;
}
